export function validateWorkoutGoalForm(formValues, formImages, isEdit) {
  let errors = {};

  if (!formValues.workoutName) {
    errors.workoutName = "required";
  }

  if (!formValues.description) {
    errors.description = "required";
  }

  if (formValues.description && formValues.description?.length < 20) {
    errors.description = "required";
  }

  if (!isEdit && formImages.workoutImage.length === 0) {
    errors.workoutImage = "required!";
  }

  return errors;
}

export function validateTestimonialForm(formValues, formImages, isEdit) {
  let errors = {};

  formValues.forEach((formInput, index) => {
    let fieldErrors = {};

    console.log("formInput. ", formInput);

    if (!formInput.selCategory) {
      fieldErrors.selCategory = "Category is required";
    }

    if (!formInput.selGym) {
      fieldErrors.selGym = "Gym is required";
    }

    if (formInput.selCategory?.value === "testimonial" && !formInput.userName) {
      fieldErrors.userName = "User Name is required";
    }

    if (formInput.selCategory?.value === "testimonial" && !formInput.rating) {
      fieldErrors.rating = "Rating is required";
    }

    if (!formInput.selType) {
      fieldErrors.selType = "Meadia type is required";
    }

    if (
      !isEdit &&
      formInput.selType?.value === "image" &&
      formImages[index].image.length === 0
    ) {
      fieldErrors.image = "Image is required";
    }

    if (
      !isEdit &&
      formInput.selType?.value === "video" &&
      formImages[index].video.length === 0
    ) {
      fieldErrors.video = "Video is required";
    }

    if (
      // !isEdit &&
      formInput.selType?.value === "video" &&
      formImages[index].frames?.length > 0 &&
      !formImages[index].thumbnail
    ) {
      fieldErrors.thumbnail = "Thumbnail is required";
    }

    if (Object.keys(fieldErrors).length > 0) {
      if (!errors.fieldErrors) {
        errors.fieldErrors = [];
      }
      errors.fieldErrors[index] = fieldErrors;
    }
  });

  console.log("errors=. ", errors);

  return errors;
}
